export default __webpack_public_path__ + "0824943426f86f65f777519e31e0f6c1.jpg";